export default __webpack_public_path__ + "locales/ar-SA/SharingPanel.json?hash=094074a4cb801b2c4ee5e79caf632af2";